import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import ActionCenterNewMessage from './ActionCenterNewMessage';

loadDOMComponent({
	selector: 'react-action-center-new-message',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<ActionCenterNewMessage />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
